import {
  Card,
  CardActions,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ProcessManagerButtons } from "./ProcessManagerButtons";
import { TipsCardContent } from "./TipsCardContent";
import { NavigationButtons } from "./NavigationButtons";
import { IHomeTipSlide } from "Containers/Home/Constants";
import { Close } from "@mui/icons-material";

interface IGetStartedTipsProps {
  openGetStartedTips: boolean;
  isFinalStep: boolean;
  isStartingStep: boolean;
  setIsStartingStep: (value: boolean) => void;
  handleCloseTips: () => void;
  handleNextStep: () => void;
  handlePreviousStep: () => void;
  activeStep: number;
  startingTipImageUrl: string;
  slides: IHomeTipSlide[];
}

export const GetStartedTips = (props: IGetStartedTipsProps) => {
  const {
    openGetStartedTips,
    isFinalStep,
    isStartingStep,
    setIsStartingStep,
    handlePreviousStep,
    handleCloseTips,
    handleNextStep,
    activeStep,
    startingTipImageUrl,
    slides,
  } = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Dialog
      open={openGetStartedTips}
      onClose={(_event, reason) => {
        if (reason === "backdropClick") {
          return; // Prevent closing when clicking the backdrop
        }

        handleCloseTips();
      }}
      aria-labelledby="tips-dialog-title"
      maxWidth={"sm"}
      slotProps={{
        paper: {
          variant: "outlined",
          sx: { padding: 0, overflow: "hidden" },
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={handleCloseTips}
        sx={() => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <Close />
      </IconButton>
      <DialogContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: isSmallScreen ? "auto" : "600px",
          overflow: "hidden",
        }}
      >
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <Typography variant="h4" sx={{ fontWeight: "fontWeightSemiBold", textAlign: "center" }}>
            Ask AMI Essentials
          </Typography>

          {/* Starting Step */}
          {isStartingStep && activeStep === 0 ? (
            <Card sx={{ width: "100%" }}>
              <TipsCardContent
                IS_STARTING_STEP={true}
                CARD_TITLE="Ask AMI Essentials"
                CARD_DESCRIPTION="Learning how to interact with Ask AMI ensures that you get helpful responses. Here are few tips to get started"
                CARD_URL={startingTipImageUrl}
              />
              <CardActions>
                <ProcessManagerButtons
                  HANDLE_STARTING_CLICK={() => setIsStartingStep(false)}
                  HANDLE_FINISHING_CLICK={handleCloseTips}
                  IS_STARING_STEP={true}
                />
              </CardActions>
            </Card>
          ) : (
            // Slides
            <Card sx={{ width: "100%" }}>
              <TipsCardContent
                CARD_TITLE={slides[activeStep].title}
                CARD_DESCRIPTION={slides[activeStep].description}
                CARD_URL={slides[activeStep].imageUrl}
              />

              <CardActions>
                <NavigationButtons
                  IS_FINAL_STEP={isFinalStep}
                  IS_STARTING_SLIDE={activeStep === 0}
                  HANDLE_NEXT_CLICK={handleNextStep}
                  HANDLE_PREVIOUS_CLICK={handlePreviousStep}
                />
                {isFinalStep && (
                  <ProcessManagerButtons
                    HANDLE_STARTING_CLICK={handleCloseTips}
                    HANDLE_FINISHING_CLICK={handleCloseTips}
                    IS_STARING_STEP={false}
                  />
                )}
              </CardActions>
            </Card>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
